module.exports = __webpack_public_path__ + "static/media/download-arrow.4800ddcf.svg";